const d = (t, e, n, r) => (t.addEventListener(e, n, r), () => {
  t.removeEventListener(e, n, r);
}), P = (t, e, n, r) => {
  const s = d(
    t,
    e,
    (o) => {
      s(), n.call(t, o);
    },
    r
  );
  return s;
}, $t = {
  listen: d,
  once: P
}, R = typeof window < "u", $ = typeof navigator < "u", _ = {
  isBrowser: R,
  isNavigator: $
}, H = (t) => {
  let e = !1;
  return _.isBrowser && (e = document.activeElement === t), e;
}, V = (t) => t instanceof HTMLElement, C = (t) => q.isHTMLElement(t) ? t.tagName.toUpperCase() === "INPUT" : !1, G = (t) => t != null ? Array.from(t) : [], X = (t) => {
  const e = t.currentTarget, n = t.relatedTarget;
  return !e.contains(n);
}, q = {
  isActive: H,
  isHTMLElement: V,
  isInputElement: C,
  toArray: G,
  isOutsideBlurEvent: X
}, N = (t) => Object.prototype.toString.call(t), y = (t) => typeof t < "u", g = (t) => {
  let e = !1;
  return t == null && (e = !0), e;
}, b = (t) => !g(t), p = (t) => {
  let e = !1;
  return t.length === 0 && (e = !0), e;
}, i = (t) => g(t) || p(t), _t = (t) => y(t) && b(t) && (U(t) && !p(t) || w(t)), U = (t) => {
  let e = !1;
  return typeof t == "string" && (e = !0), e;
}, w = (t) => {
  let e = !1;
  return typeof t == "number" && !isNaN(t) && (e = !0), e;
}, z = (t) => {
  let e = !1;
  return Array.isArray(t) && (e = !0), e;
}, W = (t) => {
  const e = t;
  let n = !1;
  return e != null && typeof e.length == "number" && (n = !0), n;
}, J = (t) => {
  let e = !1;
  if (N(t) === "[object Object]") {
    const n = Object.getPrototypeOf(t);
    (n === null || n === Object.prototype) && (e = !0);
  }
  return e;
}, E = (t) => {
  let e = !1;
  return typeof t == "function" && (e = !0), e;
}, K = (t) => {
  let e = !1;
  return N(t) === "[object Date]" && (e = !0), e;
}, a = (t) => t === globalThis, Q = (t) => a(t) && a(t.window), Y = (t) => {
  let e = !1;
  return typeof t == "boolean" && (e = !0), e;
}, Ht = {
  defined: y,
  nil: g,
  notNil: b,
  empty: p,
  nilOrEmpty: i,
  string: U,
  number: w,
  array: z,
  arrayLike: W,
  plainObject: J,
  function: E,
  date: K,
  global: a,
  window: Q,
  boolean: Y
}, Z = 0, v = (Number.MAX_SAFE_INTEGER - 1) / Number.MAX_SAFE_INTEGER, I = {
  /**
   * The default random source. This is typically a Math.random
   */
  Default: Math.random,
  /**
   * A `random` source that is very close to 1.
   *
   * @returns
   */
  Min: () => Z,
  /**
   * A `random` source thats returns 0.
   *
   * @returns
   */
  Max: () => v,
  /**
   * Generates a new value using the default source.
   * @returns
   */
  next: () => I.Default()
}, tt = (t) => t.length <= 1 ? !0 : f(t).length === 1, et = (t, e) => {
  if (t.length <= 1)
    return !0;
  const n = e(t[0]);
  return t.every((r) => e(r) === n);
}, nt = (t) => t.length <= 1 ? !0 : f(t).length === t.length, rt = (t, e) => t.length <= 1 ? !0 : f(t.map(e)).length === t.length, st = (t) => t.length === 0 ? NaN : B(t) / t.length, ot = (t, e) => t.length === 0 ? NaN : k(t, e) / t.length, ct = (t, e) => {
  e < 1 && (e = 1);
  const n = [];
  for (let r = 0; r < t.length; r += e)
    n.push(t.slice(r, r + e));
  return n;
}, ut = (t, e) => {
  let n = 0;
  if (!i(t))
    for (let r = 0; r < t.length; r++)
      e(t[r], r, t) && (n += 1);
  return n;
}, lt = (t, ...e) => {
  const n = e.filter((r) => E(r));
  return t.filter((r, s, o) => n.every((u) => u(r, s, o)));
}, D = (t) => t == null ? void 0 : t[0], it = (t, e) => D(t) ?? e, ft = (t, e) => {
  const n = /* @__PURE__ */ new Map();
  if (!i(t))
    for (const r of t) {
      const s = e(r), o = n.get(s) ?? [];
      o.push(r), n.set(s, o);
    }
  return n;
}, M = (t) => {
  let e;
  return i(t) || (e = t[t.length - 1]), e;
}, O = (t, e) => M(t) ?? e, at = (t) => O(t, null), ht = (t, e) => {
  let n = -1 / 0;
  for (let r = 0; r < t.length; r++)
    n = Math.max(n, e(t[r], r, t));
  return n;
}, A = (t, e) => {
  let n = 1 / 0;
  for (let r = 0; r < t.length; r++)
    n = Math.min(n, e(t[r], r, t));
  return n;
}, gt = (t) => t ?? [], pt = (t, e) => {
  const n = [], r = Math.max(0, e);
  for (let s = 0; s < r; s++)
    n.push(t + s);
  return n;
}, mt = (t, e) => {
  const n = [];
  for (let r = 0; r < e; r++)
    n.push(t);
  return n;
}, dt = (t, e) => {
  e == null && (e = I.Default);
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const s = Math.floor(e() * (r + 1));
    s !== r && (n[r] = n[s]), n[s] = t[r];
  }
  return n;
}, Nt = (t, e) => t.slice().sort(e), yt = (t, e, n) => {
  if (n == null && (n = !0), e <= 1)
    return [t.slice()];
  const { length: r } = t, s = [];
  if (r > 0) {
    const o = Math.ceil(r / e);
    for (let u = 0; u < r; u += o)
      s.push(t.slice(u, u + o));
  }
  if (!n)
    for (let o = s.length; o < e; o++)
      s.push([]);
  return s;
}, B = (t) => {
  let e = 0;
  for (const n of t) {
    if (isNaN(n))
      return NaN;
    e += n;
  }
  return e;
}, k = (t, e) => {
  let n = 0;
  for (const r of t) {
    const s = e(r);
    if (isNaN(s))
      return NaN;
    n += s;
  }
  return n;
}, f = (t) => Array.from(new Set(t)), bt = (t, e) => {
  const n = /* @__PURE__ */ new Set(), r = [];
  for (const s of t) {
    const o = e(s), u = n.size;
    n.add(o), n.size !== u && r.push(s);
  }
  return r;
}, Ut = (t, e, n) => {
  if (n == null && (n = !0), e <= 1)
    return [t.slice()];
  const { length: r } = t, s = [];
  if (r > 0)
    for (let o = 0; o < r; o++) {
      const u = o % e;
      s.length <= u ? s.push([t[o]]) : s[u].push(t[o]);
    }
  if (!n)
    for (let o = s.length; o < e; o++)
      s.push([]);
  return s;
}, wt = (...t) => {
  const e = [], n = A(t, (r) => r.length);
  for (let r = 0; r < n; r++) {
    const s = [];
    for (const o of t)
      s.push(o[r]);
    e.push(s);
  }
  return e;
}, Vt = {
  average: st,
  averageBy: ot,
  chunk: ct,
  count: ut,
  filter: lt,
  first: D,
  firstOrDefault: it,
  groupBy: ft,
  last: M,
  lastOrDefault: O,
  lastOrNull: at,
  orEmpty: gt,
  max: ht,
  min: A,
  range: pt,
  repeat: mt,
  shuffle: dt,
  sort: Nt,
  split: yt,
  sum: B,
  sumBy: k,
  unique: f,
  uniqueBy: bt,
  wrap: Ut,
  zip: wt,
  isUniform: tt,
  isUniformBy: et,
  isDistinct: nt,
  isDistinctBy: rt
}, Et = typeof document < "u", Ct = {
  hasDom: Et
}, It = (t, e) => {
  let n = t % e;
  return n * e < 0 && (n += e), n;
}, Dt = (t, e, n) => {
  const r = Math.min(e, n), s = Math.max(e, n);
  return Math.min(s, Math.max(r, t));
}, j = Number.parseInt, x = Number.parseFloat, Mt = (t, e) => {
  e == null && (e = 10);
  const n = j(t, e);
  if (isNaN(n))
    throw new Error(`${t} could not be parsed as integer base ${e}.`);
  return n;
}, T = (t, e) => {
  let n = j(t, e ?? 10);
  return isNaN(n) && (n = null), n;
}, Ot = (t, e, n) => T(t, n) ?? e ?? 0, At = (t) => {
  const e = x(t);
  if (isNaN(e))
    throw new Error(`${t} could not be parsed as a float.`);
  return e;
}, F = (t) => {
  let e = x(t);
  return isNaN(e) && (e = null), e;
}, Bt = (t, e) => F(t) ?? e ?? 0, Gt = {
  mod: It,
  clamp: Dt,
  parseInt: Mt,
  parseIntOrNull: T,
  parseIntOrDefault: Ot,
  parseFloat: At,
  parseFloatOrNull: F,
  parseFloatOrDefault: Bt
}, h = (t, e) => t > e ? 1 : t < e ? -1 : 0, kt = (t) => (e, n) => {
  const r = t(e, n);
  return r === 0 ? 0 : -1 * r;
}, jt = (...t) => t.length === 0 ? h : (e, n) => {
  for (const r of t) {
    const s = h(r(e), r(n));
    if (s !== 0)
      return s;
  }
  return 0;
}, Xt = {
  compare: h,
  invert: kt,
  by: jt
};
let l;
const xt = new Uint8Array(16);
function Tt() {
  if (!l && (l = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !l))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return l(xt);
}
const c = [];
for (let t = 0; t < 256; ++t)
  c.push((t + 256).toString(16).slice(1));
function Ft(t, e = 0) {
  return c[t[e + 0]] + c[t[e + 1]] + c[t[e + 2]] + c[t[e + 3]] + "-" + c[t[e + 4]] + c[t[e + 5]] + "-" + c[t[e + 6]] + c[t[e + 7]] + "-" + c[t[e + 8]] + c[t[e + 9]] + "-" + c[t[e + 10]] + c[t[e + 11]] + c[t[e + 12]] + c[t[e + 13]] + c[t[e + 14]] + c[t[e + 15]];
}
const St = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), m = {
  randomUUID: St
};
function S(t, e, n) {
  if (m.randomUUID && !e && !t)
    return m.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || Tt)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ft(r);
}
const Lt = "00000000-0000-0000-0000-000000000000", Pt = () => S(), Rt = () => S().replace(/-/g, ""), qt = {
  /**
   * Represents an empty UUID.
   */
  Empty: Lt,
  /**
   * Generates and returns a new UUID v4.
   * @returns A new UUID v4 string.
   */
  next: Pt,
  /**
   * Generates and returns a new 32-character UUID string without hyphens.
   * @returns A 32-character UUID string without hyphens.
   */
  next32: Rt
};
function zt(t, e) {
  if (!t)
    return "";
  let n = "";
  const r = t.replace(/[^0-9*]/g, "");
  switch (r.length) {
    case 7:
      n = r.slice(0, 3) + "-" + r.slice(3);
      break;
    case 10:
      n = (e != null && e.useBrackets ? "(" : "") + r.slice(0, 3) + (e != null && e.useBrackets ? ") " : "-") + r.slice(3, 6) + "-" + r.slice(6);
      break;
    case 11:
      n = r.slice(0, 1) + (e != null && e.useBrackets ? " (" : " ") + r.slice(1, 4) + (e != null && e.useBrackets ? ") " : "-") + r.slice(4, 7) + "-" + r.slice(7);
      break;
  }
  return n;
}
function Wt(t) {
  if (!t || t.length < 2)
    return "";
  const e = t.replace(/\s+/g, " ").split(" ");
  return e.length > 1 ? `${e[0].charAt(0)}${e[1].charAt(0)}` : `${t.slice(0, 2)}`.toUpperCase();
}
const L = (t, e = {}) => {
  for (const n in t) {
    const r = t[n];
    Object.prototype.hasOwnProperty.call(t, n) && (typeof r == "object" && r !== null && !Array.isArray(r) ? L(r, e) : e[n] = t[n]);
  }
  return e;
}, Jt = {
  getFlattenedObject: L
};
export {
  Vt as Arrays,
  Ct as BrowserFeatures,
  Xt as Comparer,
  $t as Events,
  Ht as Is,
  q as Nodes,
  Gt as Numbers,
  Jt as Objects,
  _ as Platform,
  I as RandomSource,
  qt as UUID,
  st as average,
  ot as averageBy,
  jt as by,
  ct as chunk,
  Dt as clamp,
  h as compare,
  ut as count,
  lt as filter,
  D as first,
  it as firstOrDefault,
  zt as formatPhone,
  Pt as generateUUID,
  Rt as generateUUID32,
  L as getFlattenedObject,
  Wt as getInitialsFromName,
  ft as groupBy,
  Et as hasDom,
  kt as invert,
  z as isArray,
  W as isArrayLike,
  Y as isBoolean,
  R as isBrowser,
  K as isDate,
  y as isDefined,
  nt as isDistinct,
  rt as isDistinctBy,
  p as isEmpty,
  E as isFunction,
  a as isGlobal,
  $ as isNavigator,
  g as isNil,
  i as isNilOrEmpty,
  b as isNotNil,
  _t as isNotUndefinedNilEmptyNaN,
  w as isNumber,
  J as isPlainObject,
  U as isString,
  tt as isUniform,
  et as isUniformBy,
  Q as isWindow,
  M as last,
  O as lastOrDefault,
  at as lastOrNull,
  ht as max,
  A as min,
  It as mod,
  gt as orEmpty,
  At as parseFloat,
  Bt as parseFloatOrDefault,
  F as parseFloatOrNull,
  Mt as parseInt,
  Ot as parseIntOrDefault,
  T as parseIntOrNull,
  pt as range,
  mt as repeat,
  dt as shuffle,
  Nt as sort,
  yt as split,
  B as sum,
  k as sumBy,
  N as toTagString,
  f as unique,
  bt as uniqueBy,
  Ut as wrap,
  wt as zip
};
